import React from 'react'
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

const PlaceMonument = () => {
    const parks = [
        {
            "NAME": "Bears Ears National Monument",
            "LAND ADMINISTRATOR": "Bureau of Land Management",
            "Address": "San Juan County, Utah, United States",
            "Phone No:": "435-587-1500",
            "Website": "https://www.blm.gov/visit/bears-ears-national-monument",
            "Established on": "28 December 2016"
        },
        {
            "NAME": "Cedar Breaks National Monument",
            "LAND ADMINISTRATOR": "National Park Service",
            "Address": "Brian Head, UT 84719, United States",
            "Phone No:": "435-986-7120",
            "Website": "https://www.nps.gov/cebr/index.htm",
            "Established on": "22 August 1933"
        },
        {
            "NAME": "Dinosaur National Monument",
            "LAND ADMINISTRATOR": "National Park Service",
            "Address": "Utah, United States",
            "Phone No:": "435-781-7700",
            "Website": "https://www.nps.gov/dino/index.htm",
            "Established on": "4 October 1915"
        },
        {
            "NAME": "Grand Staircase-Escalante National Monument",
            "LAND ADMINISTRATOR": "Bureau of Land Management",
            "Address": "Utah, United States",
            "Phone No:": "435-826-5499",
            "Website": "https://www.blm.gov/programs/national-conservation-lands/utah/grand-staircase-escalante-national-monument",
            "Established on": "18 September 1996"
        },
        {
            "NAME": "Hovenweep National Monument",
            "LAND ADMINISTRATOR": "National Park Service",
            "Address": "Montezuma Creek, UT 84534, United States",
            "Phone No:": "970-562-4282",
            "Website": "https://www.nps.gov/hove/index.htm",
            "Established on": "2 March 1923"
        },
        {
            "NAME": "Jurassic National Monument",
            "LAND ADMINISTRATOR": "Bureau of Land Management",
            "Address": "5475 Dinosaur Quarry Rd, Cleveland, UT 84518, United States",
            "Phone No:": "435-636-3600",
            "Website": "https://www.blm.gov/programs/national-conservation-lands/utah/jurassic-national-monument",
            "Established on": "4 October 1915"
        },
        {
            "NAME": "Natural Bridges National Monument",
            "LAND ADMINISTRATOR": "National Park Service",
            "Address": "Utah 84533, United States",
            "Phone No:": "435-692-1234",
            "Website": "https://www.nps.gov/nabr/index.htm",
            "Established on": "16 April 1908"
        },
        {
            "NAME": "Rainbow Bridge National Monument",
            "LAND ADMINISTRATOR": "National Park Service",
            "Address": "Forbidding Canyon Lake, Powell, UT 84533, United States",
            "Phone No:": "928-608-6200",
            "Website": "https://www.nps.gov/rabr/index.htm",
            "Established on": "30 May 1910"
        },
        {
            "NAME": "Timpanogos Cave National Monument",
            "LAND ADMINISTRATOR": "National Park Service",
            "Address": "2038 E Alpine Lp Rd, American Fork, UT 84003, United States",
            "Phone No:": "801-756-5239",
            "Website": "https://www.nps.gov/tica/index.htm",
            "Established on": "14 October 1922"
        }
    ]
    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
            {/* Landing Section */}
            <LandingSection
                data={{ imageName: "monument1.webp", title: "National Monuments" }}
            />

            {/* Main Content */}
            <div className=" mx-auto  py-12 w-full">
                {/* Intro Section */}
                <div className="text-center mb-12">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
                        Utah's National Monuments
                    </h1>
                    <p className="text-xl text-blue-700">
                        Marvel at Utah’s striking natural and cultural monuments
                    </p>
                </div>

                {/* Parks Table */}
                <div className='flex items-center justify-center'>
                    <div className="bg-white rounded-xl  shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
                        <div className="overflow-x-auto">
                            <table className="min-w-full ">
                                <thead className="bg-gradient-to-r from-blue-50 to-blue-100">
                                    <tr>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Name
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Land Administrator
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Contact
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Website
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Established
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {parks.map((park, index) => (
                                        <tr key={index} className="hover:bg-blue-50 transition-colors">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park.NAME}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["LAND ADMINISTRATOR"]}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["Phone No:"]}</div>
                                                <div className="text-sm text-center font-bold text-blue-900">{park.Address}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                <a
                                                    href={park.Website}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-600 font-bold hover:text-blue-800 hover:underline"
                                                >
                                                    Visit Website
                                                </a>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-center font-bold text-blue-900">
                                                {park["Established on"]}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}

export default PlaceMonument
